import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type PaginatedResults } from "shared/api/types/pagination";
import { type SocietyProfileParamsInput } from "shared/api/types/society/[societyId]/profiles/[profileId]";
import { type InvoiceView } from "shared/mappers/database/accounting/invoice/invoice";
export const getSocietyProfileInvoicesContract: BaseApiContract<
  SocietyProfileParamsInput,
  undefined,
  PaginatedResults<InvoiceView>
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/profiles/[profileId]/invoices",
  paramsType: {} as SocietyProfileParamsInput,
  responseType: {} as PaginatedResults<InvoiceView>,
};
